/**
 * Typed env helper: returns the value or throws in development.
 * Use for required env vars to avoid unchecked `process.env.X as string` casts.
 */
export function requireEnv(value: string | undefined, key: string): string {
	if (value === undefined || value === '') {
		if (process.env.NODE_ENV === 'development') {
			throw new Error(`Missing required env: ${key}`);
		}
		return '';
	}
	return value;
}
